import React from 'react';
import styled from 'styled-components';
import { Link, match } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Layout from 'components/templates/layout';
import { useIntl } from 'common/config/i18n';
import { MessagesMasksSelectors } from 'common/config/store';
import FormConstitution from 'components/templates/form-constitution';
import Card from 'components/molecules/card';

interface Props {
  match: match<{
    id: string;
  }>;
}

const Wrapper = styled.div`
  margin: 5px;
`;

const BreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;

const ConstitutionPage: React.FC<Props> = (props) => {
  const { t } = useIntl();
  const { id } = props.match.params;

  const messageMask = useSelector(MessagesMasksSelectors.messagesMasksSelector);

  const title = t('ConstitutionPage', 'CONSTITUTION_UPDATE');

  const constitution = id ? messageMask.find((messageMask) => messageMask?.id?.toString() === id) : undefined;

  return (
    <div>
      <Layout />
      <Wrapper>
        <BreadcrumbWrapper>
          <Link to="/constitution">{t('ConstitutionPage', 'CONSTITUTION_BACK')}</Link>
        </BreadcrumbWrapper>
        <Card width={550} title={title} titleSize="20px" wrapperStyle={{ paddingTop: 40 }}>
          <FormConstitution constitution={constitution} isUpdate />
        </Card>
      </Wrapper>
    </div>
  );
};

export default ConstitutionPage;
